import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/src/locale/es.ts';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#FF4132',
                secondary: '#b0bec5',
                accent: '#fff',
                error: '#b71c1c',
                third: '#00e8cc',
                textbox: '#1867c0'
            },
            dark:{
                primary: '#424242',
                secondary: '#263238',
                accent: '#fff',
                error: '#b71c1c',
                third: '#00e8cc',
                textbox: '#1867c0'
            }
          },
      },
    lang: {
        locales: { es },
        current: 'es'
    }
});
